import { useState, useEffect, useCallback } from 'react';
import { ENDPOINTS, normalizeCarriers } from '../api/api';

const safe = (p) => p.catch(() => null);

export function useSchoolData(schoolName, page = 1, search = '') {
  const [state, setState] = useState({ loading: true, devicesLoading: true, error: null });
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  useEffect(() => {
    if (!schoolName) return;
    setState((s) => ({ ...s, loading: true, error: null }));

    Promise.all([
      fetch(ENDPOINTS.school(schoolName)).then((r) => r.json()),
      safe(fetch(ENDPOINTS.schoolByGrade(schoolName)).then((r) => r.json())),
    ])
      .then(([summary, byGrade]) => {
        if (!summary) {
          setState((s) => ({ ...s, loading: false, error: 'Failed to load school data' }));
          return;
        }
        setState((s) => ({
          ...s,
          loading: false,
          error: null,
          schoolDisplayName: summary.name ?? null,
          stats: {
            devices: (summary.totalDevices ?? 0).toLocaleString(),
          },
          carriers: normalizeCarriers(summary.carrierStats ?? []),
          byGrade:  Array.isArray(byGrade) ? byGrade : [],
        }));
      })
      .catch((err) => setState((s) => ({ ...s, loading: false, error: err.message })));
  }, [schoolName, refreshKey]);

  useEffect(() => {
    if (!schoolName) return;
    setState((s) => ({ ...s, devicesLoading: true }));

    safe(fetch(ENDPOINTS.schoolDevices(schoolName, page, 10, search)).then((r) => r.json()))
      .then((paginated) => {
        setState((s) => ({
          ...s,
          devicesLoading: false,
          devices:    paginated?.devices   ?? [],
          totalPages: paginated?.totalPages ?? 1,
        }));
      });
  }, [schoolName, page, search, refreshKey]);

  return { ...state, refresh };
}
